'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002410 from "./presto.-Presto$$anon$10.js";
import * as $j_presto$002etypes$0024$002dCompact$002dFeature$0024 from "./presto.types$-Compact-Feature$.js";
import * as $j_presto$002etypes$0024$002dFeature$002dCode$0024 from "./presto.types$-Feature-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$9() {
  this.bcA = null;
  this.bcs = null;
  this.bct = false;
  this.bcB = null;
  this.bcC = false;
  this.bcF = null;
  this.bcy = null;
  this.bcz = false;
  this.bcu = null;
  this.bcv = false;
  this.bcw = null;
  this.bcx = false;
  this.bcD = false;
  this.bcE = false;
  this.bcA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bcF = "CompactFeature";
}
export { $c_Lpresto_Presto$$anon$9 as $c_Lpresto_Presto$$anon$9 };
$p = $c_Lpresto_Presto$$anon$9.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$9;
/** @constructor */
function $h_Lpresto_Presto$$anon$9() {
}
export { $h_Lpresto_Presto$$anon$9 as $h_Lpresto_Presto$$anon$9 };
$h_Lpresto_Presto$$anon$9.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bcA;
});
$p.L = (function() {
  if ((!this.bct)) {
    this.bcs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bct = true;
  }
  return this.bcs;
});
$p.O = (function() {
  if ((!this.bcC)) {
    this.bcB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bcC = true;
  }
  return this.bcB;
});
$p.E = (function() {
  return this.bcF;
});
$p.t = (function() {
  if ((!this.bcz)) {
    this.bcy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("value", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bcz = true;
  }
  return this.bcy;
});
$p.M = (function() {
  if ((!this.bcv)) {
    this.bcu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dFeature$002dCode$0024.$m_Lpresto_types$FeatureCode$().adu(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bcv = true;
  }
  return this.bcu;
});
$p.Q = (function() {
  if ((!this.bcx)) {
    this.bcw = new $j_presto$002e$002dPresto$0024$0024anon$002410.$c_Lpresto_Presto$$anon$10();
    this.bcx = true;
  }
  return this.bcw;
});
$p.w = (function() {
  if ((!this.bcE)) {
    this.bcD = false;
    this.bcE = true;
  }
  return this.bcD;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee70) => ((p) => \u03b4scrutinee70.ad8(p)))($j_presto$002etypes$0024$002dCompact$002dFeature$0024.$m_Lpresto_types$CompactFeature$())));
});
var $d_Lpresto_Presto$$anon$9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$9, "presto.Presto$$anon$9", ({
  Nk: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$9 as $d_Lpresto_Presto$$anon$9 };
//# sourceMappingURL=presto.-Presto$$anon$9.js.map
